<script lang="ts" setup>
import JncyLayout from '../jncy-layout/Layout.vue';
import BrowserSuggest from '../BrowserSuggest.vue';
import Header from './Header.vue';
import Footer from './Footer.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useJncyLayout } from '@/composables/useJncyLayout';
import { useLayout } from "@/composables/useLayout"
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { isInAppEnvironment } from '@/pages/course/composables/coursePlay/utils';

const route = useRoute();
const { showJncyLayout } = useJncyLayout();
const { layheader } = useLayout()
const isAi = computed(() => {
  // 检查当前页面是否为 AI 助手页面
  return (
    window.location.pathname.includes('AIAssistant.html') ||
    route.path.includes('AIAssistant') ||
    window.location.href.includes('AIAssistant.html')
  );
});

// 判断是否在 app 环境
const isInApp = computed(() => isInAppEnvironment());

const minheight = computed(()=>{
  // 在 app 环境下，不显示头部和尾部，使用全屏高度
  if (isInApp.value) {
    return '100vh';
  }
  const headerheight = layheader.value ? layheader.value.clientHeight : 0;
 if(headerheight){
  return `calc(100vh - ${headerheight}px - 260px)`;
 }else{
  return `calc(100vh - 80px - 260px)`;
 }
})
</script>
<template>
  <el-config-provider :locale="zhCn">
    <div>
      <BrowserSuggest />
      <JncyLayout v-if="showJncyLayout" />

      <template v-else>
        <Header v-if="!isAi && !isInApp" />
        <div :style="{ minHeight: minheight }" class="layout-content">
          <RouterView />
        </div>
        <Footer v-if="!isAi && !isInApp" />
      </template>
    </div>
  </el-config-provider>
</template>
